export type Activity = {
  time: string;
  place: string;
};

export type Timeline = {
  date: string;
  activities: Activity[];
}[];

export enum Colors {
  Background,
  Primary,
  Secondary,
  Tertiary,
}

export type Position = {
  x: number;
  y: number;
};

export type ContextType = {
  timeline: Timeline;
  setTimeline: (timeline: Timeline) => void;
  mainText: string;
  setMainText: (mainText: string) => void;
  suppText: string;
  setSuppText: (suppText: string) => void;
  caption: string;
  setCaption: (caption: string) => void;
  gender: 'male' | 'female' | 'url';
  setGender: (gender: 'male' | 'female' | 'url') => void;
  profile?: string;
  setProfile: (profile: string) => void;
  colors: string[];
  setColors: (colors: string[]) => void;

  setDate: (date: string, dateIndex: number) => void;
  setTime: (time: string, dateIndex: number, activityIndex: number) => void;
  setPlace: (place: string, dateIndex: number, activityIndex: number) => void;
  addDate: (dateIndex?: number) => void;
  removeDate: () => void;
  addActivity: (dateIndex: number, activityIndex: number) => void;
};
